export enum ENUM__color_compensation {
  NONE = 'None',
  SDXL = 'SDXL',
}
